import { useState, cloneElement } from 'react';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/** Wrapper component that has a list Accordion Components */
export const AccordionGroup = props => {
  const {
    children,
    defaultOpen,
    accordionType = 'single-expanded',
    onChange,
    id,
    contained = false,
    className,
    ...rest
  } = props;
  const [expanded, setExpanded] = useState(defaultOpen !== undefined ? defaultOpen.map(item => 'AccordionGroup' + item.toString()) : []);
  const handleChange = (panel, ind, onChangeChild) => () => {
    setExpanded(expanded.some(item => item === panel) ? [] : [panel]);
    if (onChangeChild) {
      onChangeChild();
    }
    if (onChange) {
      onChange(panel, ind);
    }
  };
  const noSaveHandleChange = (panel, ind, onChangeChild) => () => {
    if (onChangeChild) {
      onChangeChild();
    }
    if (onChange) {
      onChange(panel, ind);
    }
  };
  const accordionChildren = () => {
    const _children = Array.isArray(children) ? children : [children];
    const _defaultExpanded = expanded.concat(_children.map((child, ind) => child.props.defaultExpanded ? `AccordionGroup${ind}` : undefined));
    return _children.map((child, ind) => {
      const _className = className ? `AccordionGroup${ind.toString()} ${className}` : `AccordionGroup${ind.toString()}`;
      const {
        onChange,
        ...childRest
      } = child.props;
      const _id = childRest.id;
      const _dataTestId = childRest['data-testid'];
      if (accordionType === 'single-expanded') {
        return /*#__PURE__*/cloneElement(child, {
          key: _className,
          id: _id ? _id : id ? `${id}-${ind.toString()}` : undefined,
          expanded: _defaultExpanded[0] === _className,
          className: childRest.className ? [_className, childRest.className].join(' ') : _className,
          onChange: handleChange(_className, ind, onChange),
          accordionType,
          contained,
          ...childRest,
          'data-testid': _dataTestId ? _dataTestId : rest['data-testid'] ? `${rest['data-testid']}-${ind.toString()}` : undefined
        });
      }
      return /*#__PURE__*/cloneElement(child, {
        key: _className,
        id: _id ? _id : id ? `${id}-${ind.toString()}` : undefined,
        defaultExpanded: _defaultExpanded.some(item => item === _className),
        className: childRest.className ? [_className, childRest.className].join(' ') : _className,
        onChange: noSaveHandleChange(_className, ind, onChange),
        accordionType,
        contained,
        ...childRest,
        'data-testid': _dataTestId ? _dataTestId : rest['data-testid'] ? `${rest['data-testid']}-${ind.toString()}` : undefined
      });
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: accordionChildren()
  });
};